import React, { useEffect, useState } from 'react'
import { Box, Button, Modal, TextField, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useAskQuestionMutation } from '../store/api/vacanciesApi'

interface Props {
	isOpen: boolean
	onClose: () => void
}

const QuestionModal: React.FC<Props> = ({ isOpen, onClose }) => {
	const [question, setQuestion] = useState('')
	const params = useParams()
	const [ask, { isLoading, isSuccess }] = useAskQuestionMutation()

	const handleSubmit = () => {
		ask({
			candidate_id: params.candidateId,
			vacancy_id: params.id,
			extra_notes: question,
		})
	}

	useEffect(() => {
		if (!isLoading && isSuccess) {
			setQuestion('')
			onClose()
		}
	}, [isLoading])

	return (
		<Modal open={isOpen} onClose={onClose}>
			<Box
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: 400,
					bgcolor: 'background.paper',
					boxShadow: 24,
					p: 4,
					borderRadius: 2,
				}}
			>
				<Typography variant="h6" component="h2" sx={{ mb: 2 }}>
					Напишіть уточнюючий запит
				</Typography>
				<TextField
					fullWidth
					multiline
					rows={4}
					variant="outlined"
					label="Уточнення"
					value={question}
					onChange={(e) => setQuestion(e.target.value)}
					sx={{ mb: 2 }}
				/>
				<Button
					disabled={question.length === 0}
					fullWidth
					loading={isLoading}
					variant="contained"
					color="primary"
					onClick={handleSubmit}
				>
					Відправити
				</Button>
			</Box>
		</Modal>
	)
}

export default QuestionModal
